import {post} from "@/axios/request";

export const postAccessPageInfo = data => {
  return post("/auditLog/api/audit/log/postAccessPageInfo", data)
}


export const checkReservationQueue = data => {
  return post("/service/api/client/extend/checkReservationQueue", data)
}
